import React, {Component} from 'react';
import {Translation} from 'react-i18next';

import PlannerToDoSuggestedForm from '../containers/PlannerToDoSuggestedFormContainer';
import DocumentHead from '../../../elements/components/DocumentHead';
import Logger from '../../../../../lib/Logger';

class PlannerToDoSuggestedEditScreen extends Component {

  scrollToTop = () => {
    Logger.log('debug', `PlannerToDoSuggestedEditScreen.scrollToTop()`);
    if (typeof window !== 'undefined') {
      setTimeout(() => window.scrollTo(0, 0), 100);
    }
  }

  render() {
    return (
      <Translation>{(t) => 
        <div>
          <DocumentHead title={t('planner_to_do_suggested_route_edit')} />
          <PlannerToDoSuggestedForm id={this.props.match.params.id} />
        </div>
      }</Translation>
    )
  }

  /* LIFECYCLE EVENTS */

  componentDidMount() {
    this.scrollToTop();
  }
}

export default PlannerToDoSuggestedEditScreen;

Logger.log('silly', `PlannerToDoSuggestedEditScreen loaded.`);